import { Api } from '@/api/api.client';
import type { Components } from '@/api/generated/api';

export async function fetchExternalMaterialRecommendations(params: {
  schoolSubjectId?: number | null;
  schoolClassId?: number;
  search?: string;
}): Promise<Components.Schemas.RecommendedExternalMaterialDto[]> {
  const res = await Api.Routes.ExternalMaterialRecommender.recommendMaterials({
    schoolSubjectId: params.schoolSubjectId == null ? undefined : String(params.schoolSubjectId),
    schoolClassId: params.schoolClassId != null ? String(params.schoolClassId) : undefined,
    search: params.search,
  });
  return res.rows;
}

export async function createCustomExternalMaterial(params: {
  name: string;
}): Promise<Components.Schemas.RecommendedExternalMaterialDto> {
  const res = await Api.Routes.ExternalMaterial.createCustom(null, { name: params.name });
  return res.data;
}
